interface StreamPart {
  readonly type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly data?: any;
}

/**
 * Names of the tools an assistant turn ran, in first-seen order, without
 * duplicates.
 *
 * The backend names a tool in two places: `data-thinking.groupKey` (the stable
 * per-tool key it sends when a tool starts) and `data-tool-call.toolName`.
 * Both are read so the host sees a tool whichever event carried it.
 */
export function readTurnToolNames(parts?: ReadonlyArray<StreamPart>): string[] {
  if (!parts) return [];
  const names = new Set<string>();
  for (const part of parts) {
    const name = toolNameOf(part);
    if (name) names.add(name);
  }
  return Array.from(names);
}

function toolNameOf(part: StreamPart): string | null {
  if (part.type === 'data-thinking') return nonEmpty(part.data?.groupKey);
  if (part.type === 'data-tool-call') return nonEmpty(part.data?.toolName);
  return null;
}

function nonEmpty(value: unknown): string | null {
  return typeof value === 'string' && value !== '' ? value : null;
}
